<template>
  <div class="shipping-zone-discount">
    <div class="text-right">
      <div class="shipping-zone-discount-original-rate">
        ${{ originalRate }}
      </div>
      <div class="shipping-zone-discount-amount">
        <a
          class="shipping-zone-discount-link"
          @click.stop="openModal"
        >
          Your {{ discountPercentage }}% Discount
        </a>
        <em class="discount-amount">
          -${{ discountAmount }}
        </em>
      </div>
    </div>
    <modal-dialogue
      ref="modal"
      :title="modalTitle"
    >
      <div class="discount-explanation">
        We're working hard to improve our shipping efficiencies,
        and as one of those improvements your delivery
        location will now receive an ongoing {{ discountPercentage }}% discount
        on {{ shippingMethod }} shipping. No action is required on your
        end, so sit back and enjoy the savings!
      </div>

      <template v-slot:footer>
        <button class="btn btn-primary" @click.prevent="closeModal">
          Ok
        </button>
      </template>
    </modal-dialogue>
  </div>
</template>

<script>
  import ModalDialogue from '../modal-dialog';

  export default {
    components: {
      ModalDialogue
    },
    props: {
      shippingMethod: {
        type: String,
        required: true
      },
      originalRate: {
        type: String,
        required: true
      },
      discountPercentage: {
        type: Number,
        required: true
      },
      discountAmount: {
        type: String,
        required: true
      }
    },
    computed: {
      modalTitle() {
        return `Hooray! You've qualified for a ${this.discountPercentage}% discount!`;
      }
    },
    methods: {
      openModal() {
        this.$refs.modal.open();
      },
      closeModal() {
        this.$refs.modal.close();
      }
    }
  };
</script>
